export default __webpack_public_path__ + "static/media/icon-coin-glm.c4e10ef6.svg";